import script from "./InvoiceSection7.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceSection7.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceSection7.vue?vue&type=style&index=0&id=63c1519b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63c1519b"]])

export default __exports__